module.exports = __webpack_public_path__ + "img/vertical_7_3_7016.222338e3.png";